<template>
  <div>
    <div v-if="showCookiesTooltip" class="cookies-button"
         v-b-tooltip.hover.right title="Ustawienia cookies" @click="openModal">
      <i class="fa fa-cookie-bite"></i>
    </div>
    <b-modal :id="id"
             lazy
             centered
             ok-variant="ls"
             size="lg"
             title="Ciasteczka"
             cancel-title="Nie akceptuję"
             footer-class="justify-content-between"
             ok-title="Rozumiem i akceptuję"
             @cancel="dismiss"
             @ok="allowAndBootstrap"
             hide-header
             @hidden="onHidden"
             no-close-on-backdrop
             no-close-on-esc
    >
      <div class="d-flex">
        <img src="@/assets/cookie.svg" alt="" class="cookie mx-auto mt-4">
      </div>
      <div class="d-flex flex-column mt-5">
        <h4 class="mx-auto"><strong>Informacja o cookies</strong></h4>
        <p class="mt-4 text-justify">
          Serwis wykorzystuje pliki cookies w celach {{ trackers.join(' i ') }}. Więcej informacji znajdziesz w
          <a href="#" @click="openPrivacyPolicy">polityce prywatności</a>. Jeżeli wyrażasz zgodę na ich wykorzystywanie,
          kliknij w przycisk „Rozumiem i akceptuję”. Jeżeli nie wyrażasz zgody, kliknij w przycisk "Nie akceptuję".
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {bootstrap, setOptions} from "vue-gtag";
import {PRIVACY_POLICY} from "@/utils/PageModalTypes";
import Cookies from "js-cookie";
import {bootstrap as fpBootstrap} from '@/utils/FacebookPixel';

export default {
  name: "CookiesModal",
  data() {
    return {
      id: 'cookies-modal',
      showCookiesTooltip: false,
      refreshOnClose: false,
      initialized: false,
      pixelInitialized: false,
    }
  },
  mounted() {
    this.clearCookies();

    //wait for settings
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'SET_SETTINGS') {
        this.initialize();
      }
    })
  },
  methods: {
    ...mapActions([
      'setPageModal'
    ]),
    initialize() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      if (!this.analytics.ua && !this.analytics.ga4 && !this.analytics.fbp) {
        return;
      }

      if (!this.analytics.cookiesBanner) {
        this.allowAndBootstrap(false);
        return;
      }

      this.showCookiesTooltip = true;

      if (this.dismissCookies) {
        return; //cookies dismissed skip
      }

      if (this.allowCookies) {
        this.allowAndBootstrap();
        return;
      }

      this.$bvModal.show('cookies-modal')
    },
    dismiss() {
      localStorage.removeItem(this.allowStorageKey);
      localStorage.setItem(this.dismissStorageKey, 'true');
    },
    allowAndBootstrap(createAllowLocalStorageItem = true) {
      this.refreshOnClose = false;
      localStorage.removeItem(this.dismissStorageKey);

      if (createAllowLocalStorageItem) {
        localStorage.setItem(this.allowStorageKey, 'true');
      }

      const configId = this.analytics.ua || this.analytics.ga4;
      const includes = this.analytics.ua && this.analytics.ga4
          ? [{id: this.analytics.ga4}]
          : [];

      setOptions({config: {id: configId,}, includes});
      bootstrap();

      if (this.analytics.fbp) {
        //user authorized, init pixel
        if (this.isAuthorized && this.user.email.length) {
          this.initFbPixel();
        } else {
          //wait for user
          this.$store.subscribe((mutation) => {
            if (mutation.type === 'SET_USER') {
              this.initFbPixel();
            }
          })
        }
      }
    },
    initFbPixel() {
      if (this.pixelInitialized) {
        return;
      }

      this.pixelInitialized = true;

      fpBootstrap()
          .then(() => this.$analytics.fbq.init(this.analytics.fbp, {
            em: this.user.email,
          }))
          .then(() => window.fbq('track', 'PageView'));
    },
    openPrivacyPolicy() {
      this.setPageModal({
        show: true,
        type: PRIVACY_POLICY,
        title: 'Polityka prywatności',
        content: ''
      });
    },
    openModal() {
      this.refreshOnClose = true;
      this.$bvModal.show(this.id);
    },
    onHidden() {
      if (this.refreshOnClose) {
        window.location.reload();
      }
    },
    clearCookies() {
      const cookies = Cookies.get();
      const domains = [
        '.app.loyaltystarter.io',
        'app.loyaltystarter.io',
        '.loyaltystarter.io',
        '.' + location.hostname.split('.').slice(-2).join('.'),
      ];

      for (const [key,] of Object.entries(cookies)) {
        if (key === 'PHPSESSID') {
          continue;
        }

        if (this.allowCookies && this.analytics.ua && key.includes(this.analytics.ua)) {
          continue;
        }

        if (this.allowCookies && this.analytics.ga4 && key.includes(this.analytics.ga4.split('-')[1])) {
          continue;
        }

        if (this.allowCookies && key.includes('_ga')) {
          continue;
        }

        if (this.allowCookies && key.includes('_gid')) {
          continue;
        }

        if (this.analytics.gtm) {
          continue;
        }

        for (const domain of domains) {
          Cookies.remove(key, {path: '/', domain})
        }
      }
    }
  },
  computed: {
    ...mapState({
      analytics: state => state.settings.analytics,
      entityUuid: state => state.auth.entity.uuid,
      isAuthorized: state => state.auth.isAuthorized,
      user: state => state.auth.user,
    }),
    dismissStorageKey() {
      return `ls-dismiss-cookies-${this.entityUuid}`;
    },
    dismissCookies() {
      return localStorage.getItem(this.dismissStorageKey) === 'true';
    },
    allowStorageKey() {
      return `ls-allow-cookies-${this.entityUuid}`;
    },
    allowCookies() {
      return localStorage.getItem(this.allowStorageKey) === 'true';
    },
    trackers() {
      let trackers = [];

      if (this.analytics.ua || this.analytics.ga4) {
        trackers.push('analitycznych (Google Analytics)')
      }
      if (this.analytics.gtm) {
        trackers.push('analitycznych (Google Tag Manager)')
      }

      if (this.analytics.fbp) {
        trackers.push('marketingowych (Facebook Piksel)')
      }

      return trackers;
    }
  },
}
</script>

<style scoped>
.cookie {
  width: 100%;
  max-width: 150px;
  height: 100%;
  max-height: 150px;
}

.cookies-button {
  position: absolute;
  bottom: 5px;
  left: 5px;
  padding: 2px 4px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
}

@media (min-width: 768px) {
  .cookies-button > i {
    font-size: 20px;
  }
  .cookies-button {
    padding: 4px 5px;
  }
}

.cookies-button:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
}
</style>
